import {DialogActions, DialogContent} from '@mui/material';

import useProjectsCustomMappings from '../../../../hooks/providers/useProjectsCustomMappings';
import useReport from '../../../../hooks/providers/useReport';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';

const ResetCustomMappingsConfirmationModal = props => {
  const {resetProjectCustomMappings, resetCustomMappingsConfirmationModalOpen: open, setResetCustomMappingsConfirmationModalOpen: setOpen} = useProjectsCustomMappings();
  const {selectedProject} = useReport();

  const onClose = () => {
    setOpen(false);
  };

  const handleClick = () => {
    resetProjectCustomMappings(selectedProject.siren);
    onClose();
  };

  return (
    <BaseModal title="Réinitialiser le plan des comptes" maxWidth="sm" onClose={onClose} open={open}>
      <DialogContent sx={{py: 3}}>Etes-vous sûr de vouloir réinitialiser le plan des comptes ? </DialogContent>
      <DialogActions sx={{justifyContent: 'center', mb: 2}}>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={handleClick}>
          Réinitialiser
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default ResetCustomMappingsConfirmationModal;
